import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import _ from 'lodash';
import ReactApexChart from 'react-apexcharts';
import config from '../../config';

// TODO
// Error handle
// loading spinner
// possibly remove tools

class RegistrationRaceTotalChartStackedV2 extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            loading:true,
            height:props.height,
            maxHeight:props.maxHeight,
            series: [],
            options: {
                chart: {
                    height: '100%',
                    type: 'bar',
                    stacked: true,
                    // stackType: '100%'
                },
                colors: ['#9d1e1b','#c40c3e','#f15d37','#ff9801','#eda623'],
                title: {
                    text: 'Pre-Registrations by Race/Ethnicity and Phase'
                },
                plotOptions: {
                    bar: {
                        // horizontal: true,
                        columnWidth: '90%',
                    },
                },
                dataLabels: {
                    enabled: false
                },
                
                stroke: {
                    width: 1,
                    colors: ['#fff']
                },
                xaxis: {
                    type: 'category',
                    categories: [],
                    labels: {
                        formatter: function(value, timestamp, index) {
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                    },
                },
                legend: {
                    horizontalAlign: 'left',
                    offsetX: 0
                }
            },
      
      
      };
    }

    async loadOut(){
        // const qValues = qs.parse(this.props.location.search);
        let formData;
        let qResp;
        let qData;
        let qWhere="1=1";
        let url=config.apiv2.registrationRaceStage;
        let raceName=[];
        let raceActive=[];
        let raceInactive=[];
        let raceTotal=[];
        let theChartData=[];


        formData=new FormData();
        formData.append("where",qWhere);
        formData.append("outFields","*");
        formData.append("returnGeometry","false");
        formData.append("orderByFields","sortRank,race,Priority_Category");
        formData.append("returnDistinctValues","false");
        formData.append("f","json");

        try{
            qResp = await fetch(url+"/query",{method:"post",body:formData});
            qData = await qResp.json();
        }catch(err){
            console.log(err);
        }

        if(_.get(qData,"features.length",0)>0){

            const groupRace= _.chain(qData.features).groupBy("attributes.race").map((value, key) => ({ race: key, stages: value })).value();
            // console.log(groupRace);
            _.forEach(groupRace,function(value,key){
                let tempTotal=0;
                
                _.forEach(value.stages,function(valueS,keyS){
                    // need to find the specific stage array
                    tempTotal+=valueS.attributes.total;
                    let searchPhase = _.find(theChartData,{name:valueS.attributes.Priority_Category});
                    if(_.isEmpty(searchPhase)!==true){
                        //found it
                        // console.log(searchPhase)
                        searchPhase.data.push(valueS.attributes.total);
                    }else{
                        theChartData.push({
                            name:valueS.attributes.Priority_Category,
                            data:[valueS.attributes.total]
                        });
                    }
                });
                raceName.push(value.race+" - "+tempTotal);
            });

            // console.log(theChartData)





            // _.forEach(qData.features,function(value,key){
            //     // console.log(value.attributes);
            //     // raceName.push(value.attributes.race);
            //     raceActive.push(value.attributes.active);
            //     raceInactive.push(value.attributes.inactive);
            //     raceTotal.push(value.attributes.total);
            // });
            

            this.setState({
                loading:false,
                error:false,
                series:theChartData,
                options: {
                  ...this.state.options,
                  xaxis: {
                    ...this.state.options.xaxis,
                    categories:raceName,
                  },
                  yaxis: [
                    {
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                        },
                        labels: {
                            
                            formatter: function(value, timestamp, index) {
                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            }
                        },
                        title: {
                            text: "",
                        },
                        tooltip: {
                            enabled: false
                        }
                    }
                    
                ],
                tooltip: {
                    enabled: true,
                    enabledOnSeries: true,
                    shared: true,
                    followCursor: true,
                    intersect: false,
                    inverseOrder: false,
                    fillSeriesColor: false,
                    style: {
                      fontSize: '11px',
                    },
                    onDatasetHover: {
                        highlightDataSeries: true,
                    },
                    y: [{
                            formatter: function(value, timestamp, index) {
                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            },
                            title: {
                                formatter: (seriesName) => seriesName,
                            },
                    }],
                    marker: {
                        show: true,
                    },
                },
                }
            });
        }else{
            // error handle
            this.setState({
                loading:false,
                error:true
            });
        }
    }

    componentDidMount(){
        this.loadOut();
    }


    render() {
        if(this.state.loading===true){
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <div id="loader" style={{textAlign:"center"}}>
                        <Row>
                            <Col>
                                <Spinner animation="border" variant="primary" />
                            </Col>
                        </Row>
                    </div>
                </Container>
            );

        }else if(this.state.loading===false && this.state.error===true){
            //show error
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <Alert></Alert>
                </Container>
            );
        }else{
            return (
                <>
                    <div id="chart" style={{height:this.state.height,maxHeight:this.state.maxHeight,paddingRight:"0",paddingLeft:"0"}}>
                        <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={'100%'} />
                    </div>
                </>
            );
        }
    }
}

export default RegistrationRaceTotalChartStackedV2;